import React from 'react';
import { connect } from 'react-redux';
import jsonp from 'jsonp';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import constants from './constants';
import subscribe_cookie from './helper';
import { gaWrapper } from '../../../helpers/analytics';
import s from './ElectionWidget.scss';

const apiParamsObj = {
  nlid: 1029,
  configid: 64477478,
};
class ElectionWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuccessState: false,
      isAlreadySubscribed: false,
      isvalidemail: false,
      IsSubscribed: true,
    };
    this.gaFired = false;
    this.popupManagerCallback = null;
    this.moduleName = 'genderpluspopup';
    this.observer = null;
    this.intersectionCallBack = null;
    this.disappearLetter = props.disappearLetter;
  }

  CheckIfSubscribed = () => {
    if (
      !subscribe_cookie.check_IsSubscribed() !== this.state.showSuccessState
    ) {
      this.setState(
        {
          showSuccessState: !subscribe_cookie.check_IsSubscribed(),
        },
        () => {
          if (this.props.disappearLetter && this.state.showSuccessState) {
            this.setState({
              IsSubscribed: false,
            });
          }
        },
      );
    }
  };

  handleInputTextChange = evt => {
    let validemail = true;
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );
    if (!pattern.test(evt.target.value)) {
      validemail = false;
    }

    this.setState({
      inputValue: evt.target.value,
      isvalidemail: validemail,
      isAlreadySubscribed: false,
    });
  };

  alreadyVerifiedUser = emailValue => {
    /**
     * To DO
     */
    // GA EVENT : SUBSCRIBE DUPLICATE
    gaWrapper(
      'send',
      'event',
      this.props.gaCategory || constants.GA_CATEGORY,
      `subscribe_duplicate`,
    );
    this.setState({ isAlreadySubscribed: true });
    console.log('Already subscribed', emailValue);
  };

  newUser = emailValue => {
    const { NudgeSubscribeCookie } = this.props;
    this.setExpiryObject(true, false, emailValue);
    this.setState({ showSuccessState: true });
    // GA EVENT : SUBSCRIBE SUCCESS
    gaWrapper(
      'send',
      'event',
      this.props.gaCategory || constants.GA_CATEGORY,
      `subscribe_success`,
    );
    // Set the cookie that tells user subscribed from newletter nudge
    const wdtExpiryTimestamp = new Date().getTime() + 30 * 60 * 1000;
    if (
      document.location.host === 'spmdev.indiatimes.com' ||
      document.location.host === 'toidev.indiatimes.com' ||
      document.location.host === 'timesofindia.indiatimes.com'
    ) {
      subscribe_cookie.set_cookie(
        NudgeSubscribeCookie,
        Date.now(),
        365,
        '/',
        '.indiatimes.com',
        '',
      );
      if (typeof localStorage === 'object') {
        localStorage.setItem(NudgeSubscribeCookie, wdtExpiryTimestamp);
      }
    } else {
      subscribe_cookie.set_cookie(
        NudgeSubscribeCookie,
        Date.now(),
        365,
        '/',
        '.timesofindia.com',
        '',
      );
      if (typeof localStorage === 'object') {
        localStorage.setItem(NudgeSubscribeCookie, wdtExpiryTimestamp);
      }
    }
  };

  addUserEmailSubscription = (URL, emailValue) => {
    jsonp(URL, null, (err, resp) => {
      if (err) {
        // GA EVENT : SUBSCRIBE ERROR
        gaWrapper(
          'send',
          'event',
          this.props.gaCategory || constants.GA_CATEGORY,
          `subscribe_error`,
        );
        console.warn(err);
      } else if (resp) {
        if (resp.Status === 'Success') {
          if (resp.message.toLowerCase() === 'already verified user') {
            this.alreadyVerifiedUser(emailValue);
          } else {
            this.newUser(emailValue);
          }
        }
      }
    });
  };

  submitEmail = () => {
    const { apiParamsObj: { nlid, configid } } = this.props;
    const param = `?id=${
      this.state.inputValue
    }&frequency=1&scheduletime=1&status=1&nlid=${nlid}&configid=${configid}&subscriptionwithconfirmation=true&confirmationpage=timestopten`;

    if (this.state.isvalidemail) {
      // GA EVENT : CLICK
      gaWrapper(
        'send',
        'event',
        this.props.gaCategory || constants.GA_CATEGORY,
        `subscribe_initiated`,
      );
      this.addUserEmailSubscription(
        `${constants.ADD_SUBSCRIPTION_URL}${param}`,
        this.state.inputValue,
      );
    }
  };

  getTimeStampAfterGivenDays = days => {
    const date = new Date();
    const last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
    return last.getTime();
  };

  setExpiryObject(isSubscribed, isExpired, emailId, registeredEmailId = '') {
    const expiryObject = subscribe_cookie.getLocalStorage(constants.EXPIRY_KEY);
    if (!expiryObject || isSubscribed) {
      // if unsubcribed user closes the div
      const newexpiryObject = {
        isSubscribed,
        timeStamp: this.getTimeStampAfterGivenDays(constants.EXPIRY_DAYS),
        isExpired,
        emailId,
        registeredEmailId,
      };
      subscribe_cookie.setLocalStorage(
        constants.EXPIRY_KEY,
        JSON.stringify(newexpiryObject),
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData &&
      prevProps.userData.isLoggedIn !== this.props.userData.isLoggedIn
    ) {
      const emailId =
        this.props.userData &&
        this.props.userData.isLoggedIn &&
        typeof this.props.userData.getEmail === 'function'
          ? this.props.userData.getEmail()
          : '';
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        inputValue: emailId,
        isvalidemail: emailId !== '',
      });
    }
  }

  componentDidMount() {
    this.IntersectionObserverApi(this.ObserverHook);
    this.CheckIfSubscribed();
  }

  renderNudge() {
    const { wrapperClass } = this.props;
    return (
      <div className={`${s.inner} ${wrapperClass}`}>
        <div className={s.column}>
          {this.state.showSuccessState ? (
            <h4>
              {(this.props.item &&
                this.props.item.title &&
                this.props.item.title.responseheading) ||
                constants.RESPONSE_HEADING}
              {/* <span>{constants.SUB_RESPONSE_HEADING}</span> */}
            </h4>
          ) : (
            <h4>
              {(this.props.item &&
                this.props.item.title &&
                this.props.item.title.heading) ||
                constants.HEADING}
              <span>
                {(this.props.item &&
                  this.props.item.title &&
                  this.props.item.title.subheading) ||
                  constants.SUBHEADING}
              </span>
            </h4>
          )}

          {this.state.showSuccessState ? (
            <div className={s.col}>
              <p>
                {(this.props.item &&
                  this.props.item.title &&
                  this.props.item.title.responsetext) ||
                  constants.RESPONSE_TEXT}
              </p>
            </div>
          ) : (
            <div className={s.col}>
              <p>
                {(this.props.item &&
                  this.props.item.title &&
                  this.props.item.title.text) ||
                  constants.TEXT}
              </p>
              {this.state.isAlreadySubscribed ? (
                <span>
                  {(this.props.item &&
                    this.props.item.title &&
                    this.props.item.title.alreadysubscribed) ||
                    constants.ALREADY_SUBSCRIBED}
                </span>
              ) : null}
            </div>
          )}
        </div>
        <div className={`${s.column} ${s.formarea}`}>
          {this.state.showSuccessState ? null : (
            <div
              className={`${s.form} ${this.state.isvalidemail ? s.active : ''}`}
            >
              <input
                type="text"
                placeholder="Your Email Address"
                value={this.state.inputValue}
                onChange={this.handleInputTextChange}
              />
              <span className={s.errorMsg}>{constants.EMAIL_INVALID}</span>
              <input
                type="submit"
                value="Subscribe"
                onClick={this.submitEmail}
              />
            </div>
          )}
          <div className={s.msgtextprivacy}>
            By subscribing to newsletter, you acknowledge our{' '}
            <a
              href="https://timesofindia.indiatimes.com/privacy-policy/cookiepolicy/86934312.cms"
              data-eulink="https://timesofindia.indiatimes.com/privacy-policy/cookiepolicy/80245266.cms"
            >
              privacy policy
            </a>
          </div>
        </div>
      </div>
    );
  }

  IntersectionObserverApi = callback => {
    try {
      if ('IntersectionObserver' in window) {
        this.intersectionCallBack = entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0.8) {
              gaWrapper(
                'send',
                'event',
                this.props.gaCategory || constants.GA_CATEGORY,
                this.props.gaAction || `subscribe_view_election`,
                this.props.gaLabel || ``,
              );
              if (this.observer && this.observer.unobserve) {
                this.observer.unobserve(entry.target);
              }
            }
          });
        };
        if (callback && typeof callback === 'function') {
          setTimeout(() => {
            callback.call(this);
          }, 60);
        }
      }
    } catch (error) {
      console.trace(`IntersectAPI`, error);
    }
  };

  ObserverHook = () => {
    try {
      this.observer = new IntersectionObserver(this.intersectionCallBack, {
        rootMargin: '0px',
        threshold: 0.8,
      });
      if (this.observer.observe) {
        this.observer.observe(
          document.querySelector('[data-plugin="electionnudge-container"]'),
        );
      }
    } catch (error) {
      console.trace(`IntersectAPI`, error);
    }
  };

  render() {
    const { ExternalClass, InternalClass } = this.props;
    const wrapperClass = classNames({
      [s.ElectionNudge]: true,
      [ExternalClass]: ExternalClass,
      [s[InternalClass]]: InternalClass,
    });
    return this.state.IsSubscribed ? (
      <div className={`${wrapperClass}`} data-plugin="electionnudge-container">
        {this.renderNudge()}
      </div>
    ) : null;
  }
}

const mapStateToProps = state => ({
  userData: state.login && state.login.userData ? state.login.userData : {},
});
const mapDispatchToProps = () => ({});
ElectionWidget.propTypes = {
  userData: PropTypes.shape({
    getEmail: PropTypes.func,
    isLoggedIn: PropTypes.bool,
  }),
  item: PropTypes.shape({}),
  InternalClass: PropTypes.string,
  ExternalClass: PropTypes.string,
  disappearLetter: PropTypes.bool,
  apiParamsObj: PropTypes.shape({
    nlid: PropTypes.number,
    configid: PropTypes.number,
  }),
  NudgeSubscribeCookie: PropTypes.string,
};
ElectionWidget.defaultProps = {
  userData: undefined,
  item: undefined,
  ExternalClass: '',
  InternalClass: '',
  disappearLetter: false,
  apiParamsObj,
  NudgeSubscribeCookie: constants.NUDGE_SUBSCRIBE_COOKIE,
};
export default connect(mapStateToProps, mapDispatchToProps)(ElectionWidget);
